import {mappableTemplateSources} from '../creativeTemplates.consts';
import {CreativeTemplateSource} from '../creativeTemplates.types';

function isMappingSupportedTemplate(templateSource: CreativeTemplateSource) {
  return mappableTemplateSources.includes(templateSource);
}

export default isMappingSupportedTemplate;
